import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-vps",
  "use": "icon-ums-vps-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ums-vps\"><path d=\"M244.622222 597.333333L512 796.444444l267.377778-199.111111 73.955555 56.888889L512 910.222222l-341.333333-256 73.955555-56.888889zM512 682.666667L170.666667 426.666667 512 170.666667l341.333333 256L512 682.666667z\" p-id=\"3456\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-vps.svg
// module id = 0kg3
// module chunks = 67